import { Array, Boolean, Null, Number, Optional, Record, Static, String, Undefined } from 'runtypes';

import { ArchivButtonRunType } from 'src/models/archiv';
import { DocumentDetailExtrasRunType } from 'src/models/document/extras';
import { GlobalizationButtonRunType } from 'src/models/globalization';
import { IdoButtonRunType } from 'src/models/ido';
import { SpoingButtonRunType } from 'src/models/spoing';
import { StatusButtonRunType } from 'src/models/status';
import { TaskButtonRunType } from 'src/models/task';

const DesktopPanelDocumentModelPostboxesRunType = Record({
	id: Number,
	name: String,
	standard: String,
});

const DesktopPanelDocumentModelCategoriesRunType = Record({
	category: String,
	id: Number.Or(String),
	isAGlobalCategory: Boolean,
	isTheSelectedCategoryForTheDocument: Boolean,
});

const DesktopPanelDocumentModelIdoCategoriesRunType = Record({
	desktopPanelDocumentModelCategories: Array(DesktopPanelDocumentModelCategoriesRunType),
	id: String,
	idoDisplayname: String,
	idoId: Number,
	idoInstanceId: Number,
});

export type DesktopPanelDocumentModelIdoCategories = Static<typeof DesktopPanelDocumentModelIdoCategoriesRunType>;

const DesktopPanelDocumentModelVersionsExtrasRunType = Record({
	version: String,
});

export const DesktopPanelDocumentModelVersionsRunType = Record({
	aggregateId: String,
	aggregateVersion: Number,
	author: String,
	extras: DesktopPanelDocumentModelVersionsExtrasRunType,
	filename: String,
	filesize: Number,
	id: String,
	timestamp: Number,
	version: String,
});

export type DesktopPanelDocumentModelVersions = Static<typeof DesktopPanelDocumentModelVersionsRunType>;

export const DocumentDownloadLinkRunType = Record({
	link: String,
	password: String,
	validUntil: String.Or(Null),
});

export type DocumentDownloadLink = Static<typeof DocumentDownloadLinkRunType>;

export const DocumentRunType = Record({
	aggregateId: String,
	aggregateVersion: Number.Or(Undefined),
	archivButton: ArchivButtonRunType.Or(Undefined),
	author: String,
	authorId: Number,
	buzzwords: String,
	contactPicture: String,
	desktopPanelDocumentModelIdoCategories: Array(DesktopPanelDocumentModelIdoCategoriesRunType),
	desktopPanelDocumentModelPostboxes: Array(DesktopPanelDocumentModelPostboxesRunType),
	desktopPanelDocumentModelVersions: Array(DesktopPanelDocumentModelVersionsRunType),
	documentMayBeDeleted: Boolean,
	downloadLink: Optional(DocumentDownloadLinkRunType),
	extras: DocumentDetailExtrasRunType,
	filename: String,
	filesize: Number,
	globalizationButton: GlobalizationButtonRunType,
	idoButton: IdoButtonRunType,
	isPasswordLocked: Boolean,
	postbox: String,
	postboxId: Number,
	spoingButton: SpoingButtonRunType.Or(Undefined),
	statusButton: StatusButtonRunType.Or(Undefined),
	taskButton: TaskButtonRunType.Or(Undefined),
	timestamp: Number,
	title: String,
});

export type Document = Static<typeof DocumentRunType>;

export const DocumentPreviewRunType = Record({});

export type DocumentPreview = Static<typeof DocumentPreviewRunType>;

export const DocumentContentRunType = Record({});
